import { Outlet, Link } from 'react-router-dom'
import { FileArchive } from 'lucide-react'

const BRAND_NAME = import.meta.env.VITE_APP_NAME || 'ZipWin'

function BrandLogo() {
  return (
    <Link to="/" className="flex items-center gap-2">
      {import.meta.env.VITE_APP_LOGO ? (
        <img
          src={import.meta.env.VITE_APP_LOGO}
          alt={BRAND_NAME}
          className="w-8 h-8 object-contain rounded-lg"
        />
      ) : (
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#1AB956]">
          <FileArchive className="h-5 w-5 text-white" />
        </span>
      )}
      <span className="text-xl font-bold text-gray-900">{BRAND_NAME}</span>
    </Link>
  )
}

function Layout() {
  const isPromoSite = import.meta.env.VITE_DISABLE_SEO === 'true'
  const companyName = import.meta.env.VITE_COMPANY_NAME || '杭州点壹下通讯科技有限公司'

  const text = {
    contactTitle: '联系我们',
    brandDesc: `${BRAND_NAME} 是一款免费高效的压缩解压工具，支持 ZIP、7Z、RAR 等多种格式，秒速压缩解压，一键搞定。`,
    footerPrivacy: '隐私政策',
    footerTerms: '服务条款',
    footerContact: '联系我们',
    footerReturn: '退款政策',
    footerIp: '知识产权',
    footerRights: '版权所有'
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-16">
            <BrandLogo />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="min-h-[calc(100vh-64px-200px)]">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="col-span-1 md:col-span-2">
              <div className="mb-4">
                <BrandLogo />
              </div>
              <p className="text-gray-600 text-sm max-w-sm">
                {text.brandDesc}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-4">{text.contactTitle}</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>{companyName}</li>
              </ul>
            </div>
          </div>
          <div className="mt-8 border-t border-gray-200 pt-8 flex flex-col items-center gap-6 text-sm text-gray-500">
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-center sm:gap-x-6">
              <a href="/privacy.html?lang=zh" target="_blank" rel="noopener noreferrer" className="hover:text-[#1AB956] transition-colors">
                {text.footerPrivacy}
              </a>
              <a href="/terms.html?lang=zh" target="_blank" rel="noopener noreferrer" className="hover:text-[#1AB956] transition-colors">
                {text.footerTerms}
              </a>
              <a href="/contact.html?lang=zh" target="_blank" rel="noopener noreferrer" className="hover:text-[#1AB956] transition-colors">
                {text.footerContact}
              </a>
              <a href="/return-policy.html?lang=zh" target="_blank" rel="noopener noreferrer" className="hover:text-[#1AB956] transition-colors">
                {text.footerReturn}
              </a>
              <a href="/intellectual-property.html?lang=zh" target="_blank" rel="noopener noreferrer" className="hover:text-[#1AB956] transition-colors">
                {text.footerIp}
              </a>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-4 text-center">
              <span>© {new Date().getFullYear()} {companyName} {text.footerRights}</span>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-4 text-center">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="hover:text-[#1AB956] transition-colors">
                {import.meta.env.VITE_ICP_NO || '浙ICP备2023036369号'}
              </a>
              {import.meta.env.VITE_POLICE_NO !== 'none' && (
                <a
                  href={`https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${import.meta.env.VITE_POLICE_CODE || '33010502012866'}`}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-1 hover:text-[#1AB956] transition-colors"
                >
                  <img src="https://www.beian.gov.cn/img/ghs.png" alt="公安备案" className="w-4 h-4" />
                  {import.meta.env.VITE_POLICE_NO || '浙公网安备33010502012866号'}
                </a>
              )}
            </div>
          </div>
          {!isPromoSite && (
            <div className="mt-4 text-xs text-gray-500 text-center">
              <a
                href="https://mydown.yesky.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1AB956] transition-colors"
              >
                天极下载
              </a>
              <span className="mx-2 text-gray-300">|</span>
              <a
                href="https://xiazai.zol.com.cn/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1AB956] transition-colors"
              >
                ZOL软件下载
              </a>
              <span className="mx-2 text-gray-300">|</span>
              <a
                href="https://www.cr173.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1AB956] transition-colors"
              >
                西西软件园
              </a>
              <span className="mx-2 text-gray-300">|</span>
              <a
                href="http://www.downkuai.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1AB956] transition-colors"
              >
                当快软件园
              </a>
              <span className="mx-2 text-gray-300">|</span>
              <a
                href="https://www.ddooo.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1AB956] transition-colors"
              >
                多多软件
              </a>
              <span className="mx-2 text-gray-300">|</span>
              <a
                href="https://www.32r.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1AB956] transition-colors"
              >
                3322软件站
              </a>
              <span className="mx-2 text-gray-300">|</span>
              <a
                href="http://www.pc9.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1AB956] transition-colors"
              >
                PC9软件园
              </a>
              <span className="mx-2 text-gray-300">|</span>
              <a
                href="https://www.pc6.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1AB956] transition-colors"
              >
                PC6软件下载
              </a>
              <span className="mx-2 text-gray-300">|</span>
              <a
                href="https://soft.china.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1AB956] transition-colors"
              >
                中华网软件
              </a>
              <span className="mx-2 text-gray-300">|</span>
              <a
                href="http://www.jisuxz.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1AB956] transition-colors"
              >
                极速下载
              </a>
            </div>
          )}
        </div>
      </footer>
    </div>
  )
}

export default Layout
